import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { emailEditorChange, setImageUrl, selectSection } from 'actions/template'
import Editor from 'components/EditorNext'
import S3Wrapper from 'components/S3Manager/S3Wrapper'
// import SocialMedia from './SocialMedia'
import AltEditor from './AltEditor'
import './body.css'

const TemplateForm_Body = ({
	section,
	emailEditorChange,
	setImageUrl,
	selectSection,
}) => {
	if (!section) return null
	const { value, editor } = section

	const editorMap = {
		wysiwyg: 'wysiwyg',
		header: 'wysiwyg',
		divider: 'wysiwyg',
		paragraph: 'wysiwyg',
		colors: (
			<AltEditor
				fields={[
					{ label: 'background', kind: 'color', value: 'background' },
					{ label: 'foreground', kind: 'color', value: 'foreground' },
				]}
				fieldType="colors"
			/>
		),
		link: (
			<AltEditor
				fields={[
					{ label: 'url', kind: 'link', value: 'url' },
					{ label: 'text', value: 'text' },
				]}
				fieldType="linkValues"
			/>
		),
		button: (
			<AltEditor
				fields={[
					{ label: 'button text', value: 'text' },
					{ label: 'url', kind: 'link', value: 'url' },
					{ label: 'text color', value: 'textColor', kind: 'color' },
					{ label: 'background', value: 'backgroundColor', kind: 'color' },
				]}
				fieldType="buttonValues"
			/>
		),
		'image-paragraph': 'wysiwyg',
		'social-media': (
			<AltEditor
				fields={[
					{ label: 'facebook', kind: 'social', value: 'facebook' },
					{ label: 'instagram', kind: 'social', value: 'instagram' },
					{ label: 'twitter', kind: 'social', value: 'twitter' },
					{ label: 'color', kind: 'color', value: 'color' },
				]}
				fieldType="socialMediaLinkValues"
			/>
		),
		'2-columns-image-paragraph': 'wysiwyg',
		'3-columns-image-paragraph': 'wysiwyg',
		'image-banner-text': 'wysiwyg',
		'img-picker': (
			<S3Wrapper
				setImageUrl={(url, label) => {
					setImageUrl(url, label)
					// selectSection(null)
				}}
			/>
		),
	}

	return (
		<div style={{ height: '100%' }}>
			<div
				className="kendoJqueryEditor"
				style={
					editorMap[editor] === 'wysiwyg'
						? {
								/* height: '100%' */
						  }
						: { display: 'none' }
				}
			>
				<Editor
					value={editorMap[editor] === 'wysiwyg' ? value : ''}
					onChange={emailEditorChange}
				/>
			</div>
			{editorMap[editor] !== 'wysiwyg' && editorMap[editor]}
		</div>
	)
}

export default connect(
	(state) => ({
		section:
			typeof state.email.sectionSelected === 'number'
				? state.email.sections[state.email.sectionSelected]
				: typeof state.email.sectionSelected === 'string'
				? { editor: state.email.sectionSelected }
				: false,
	}),
	(dispatch) =>
		bindActionCreators(
			{ emailEditorChange, setImageUrl, selectSection },
			dispatch,
		),
)(TemplateForm_Body)
